import { Timing } from '@debbie/common/dist/economy/billing-appendix-setups/index.js';
import { Currency, Site } from '@debbie/common/dist/index.js';
import { objectBy } from '@debbie/common/dist/util/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { Link } from 'react-router-dom';
import THEME from '../../theme.js';
import Badge from '../Badge.js';
import { ExternalLink } from '../Icons/index.js';
import Money from '../Money.js';
import { FilterType } from '../PowerTable.js';
export const powerTableValues = (props) => {
    return {
        handle: {
            label: props.lang.billing.billingsAppendix,
            // @ts-ignore
            toCmp: (handle) => handle,
            // @ts-ignore
            map: (handle) => handle,
            filter: {
                type: FilterType.Category,
                categories: props.handleCategories,
            },
        },
        timingType: {
            label: props.lang.billing.billingsType,
            // @ts-ignore
            toCmp: (timingType) => timingType,
            // @ts-ignore
            map: (timingType) => props.lang.billingAppendixSetupTimings[timingType],
            filter: {
                type: FilterType.Category,
                categories: objectBy(Object.values(Timing).map((timing) => ({
                    type: timing,
                    label: props.lang.billingAppendixSetupTimings[timing],
                })), (c) => c.type),
            },
        },
        creditorName: {
            label: props.lang.billing.billingsCreditor,
            // @ts-ignore
            toCmp: (creditorName) => creditorName,
            width: '100px',
            // @ts-ignore
            map: (creditorName, row) => (React.createElement("div", { style: {
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '100px',
                }, title: `${creditorName} (${row.creditorReferenceId})` },
                React.createElement("b", null, props.site === Site.Client ? (creditorName) : (React.createElement(Link, { style: { color: 'inherit' }, to: `/creditors/${row.creditorId}` }, creditorName))),
                React.createElement("br", null),
                row.billingEmails?.to && (React.createElement("span", { title: row.billingEmails?.to }, "To")),
                ' ',
                row.billingEmails?.cc && (React.createElement("span", { title: row.billingEmails?.cc }, "cc")),
                ' ',
                row.billingEmails?.bcc && (React.createElement("span", { title: row.billingEmails?.bcc }, "bcc")))),
        },
        caseSequentialIds: {
            label: props.lang.billing.billingsCases,
            // @ts-ignore
            toCmp: (caseSequentialIds) => caseSequentialIds.length,
            // @ts-ignore
            map: (caseSequentialIds) => (React.createElement(React.Fragment, null,
                caseSequentialIds.length,
                ' ',
                React.createElement(ExternalLink, { style: { cursor: 'pointer' }, onClick: () => {
                        c.redirect.redirect(`/cases/${caseSequentialIds.join(',')}`);
                    } }))),
        },
        ...powerTableEconomicalValues({ lang: props.lang }),
        currency: {
            label: props.lang.billing.billingsCurrency,
            align: 'right',
            // @ts-ignore
            toCmp: (currency) => currency,
            // @ts-ignore
            map: (currency) => React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, currency),
            filter: {
                type: FilterType.Category,
                categories: objectBy(Object.values(Currency).map((currency) => ({
                    type: currency,
                    label: currency,
                })), (c) => c.type),
            },
        },
    };
};
export const powerTableEconomicalValues = (props) => {
    return {
        revenue: {
            label: props.lang.billing.revenue,
            align: 'right',
            // @ts-ignore
            toCmp: (revenue) => revenue,
            // @ts-ignore
            map: (revenue) => React.createElement(Money, { amount: revenue }),
            filter: {
                type: FilterType.MoneyRange,
            },
        },
        vat: {
            label: props.lang.billing.vat,
            align: 'right',
            // @ts-ignore
            toCmp: (vat) => vat,
            // @ts-ignore
            map: (vat) => React.createElement(Money, { amount: vat }),
            filter: {
                type: FilterType.MoneyRange,
            },
        },
        payout: {
            label: props.lang.billing.payout,
            align: 'right',
            // @ts-ignore
            toCmp: (payout) => payout,
            // @ts-ignore
            map: (payout) => React.createElement(Money, { amount: payout }),
            filter: {
                type: FilterType.MoneyRange,
            },
        },
        disbursements: {
            label: props.lang.billing.disbursements,
            align: 'right',
            // @ts-ignore
            toCmp: (disbursements) => disbursements,
            // @ts-ignore
            map: (disbursements) => React.createElement(Money, { amount: disbursements }),
            filter: {
                type: FilterType.MoneyRange,
            },
        },
        overpayments: {
            label: props.lang.billing.overpayments,
            align: 'right',
            // @ts-ignore
            toCmp: (overpayments) => overpayments,
            // @ts-ignore
            map: (overpayments) => React.createElement(Money, { amount: overpayments }),
            filter: {
                type: FilterType.MoneyRange,
            },
        },
        balance: {
            label: props.lang.billing.balance,
            align: 'right',
            // @ts-ignore
            toCmp: (balance) => balance,
            // @ts-ignore
            map: (balance, row) => (React.createElement(React.Fragment, null,
                React.createElement(Money, { amount: balance, color: true }),
                React.createElement("br", null),
                row.creditorBankAccount?.registrationNumber && row.balance < 0 ? (React.createElement("small", { style: { marginTop: '.5em', color: THEME.COLOR_GREY } },
                    row.creditorBankAccount?.registrationNumber,
                    ' ',
                    row.creditorBankAccount?.accountNumber)) : (''))),
            filter: {
                type: FilterType.MoneyRange,
            },
        },
    };
};
//# sourceMappingURL=billing-table-utils.js.map